import React, { Component } from 'react';
import Select from 'react-select';
import { Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn, TableFooter } from 'material-ui/Table';

import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import RaisedButton from 'material-ui/RaisedButton';
import TimePicker from 'material-ui/TimePicker';
import TextField from 'material-ui/TextField';

import Box from '../ui/Box';

import DataService from '../../services/DataService'; var ds = DataService;
import LocalStorage from '../../services/LocalStorageService';import email from 'material-ui/svg-icons/communication/email';
 var ls = LocalStorage;

const actionOptions = [
  { label: 'Yes', value: true, answer: 1 },
  { label: 'No', value: false, answer: 0 }
];
const checkedOptions = [
    { label: 'When Room is Cheked-In', value: 'Check-in'},
    { label: 'When Room is Checked-Out', value: 'Check-out'},
]

export default class AlertSetting extends Component {
  constructor(props) {
    super(props);
    this.state = {
      intrusion_alerts: {},
        alerts_status: "",
        checked_in_alerts: "",
        checked_out_alerts: "",
        checked_alerts:"",
        excluded_rooms:[],
        notification:"",
        email:false,
        sms:false,
        all_rooms: [],
        features: { 
      //     "sms" : {
      //     "enabled" : true,
      //     "is_editable" : false,
      //     "meta" : {
      //         "dlt_name" : "kiot_dlt"
      //     }
      // }
    },
        phone_numbers:[],
        email_ids:[],
      dialog: {
        open: false,
        head: 'Dude',
        body: 'This is working',
        all_services: [],
        actions: [
          <FlatButton
            label="Okay"
            primary
            onClick={this.closeDialog.bind(this)}
          />
        ]
      }
    }
  }

  componentDidMount() {
    this.getAlertSettings();
    this.getAllRooms();
  }

  getAllRooms() {
    let user = ls.getUserDetails()
    if (user.hotel_id) {
      ds.getAllRooms(user.hotel_id,
        data => {
          if (data && data.length) {
            for (let i of data) {
              i.label = i.hotel_room_id ? i.hotel_room_id.name : '';
              i.value = i.hotel_room_id._id;
            }
          }
          this.setState({
            all_rooms: data,
          })
        }, error => {
          console.log(error);
        })
    }
  }

getAlertSettings() {
    ds.getAlertSettings(ls.getUserDetails().hotel_id,
      data => {
        if(data && data.excluded_rooms){
          let exclude_rooms = [];
          if(data.excluded_rooms.length){
            for(let i of data.excluded_rooms){
              exclude_rooms.push(i._id);
            }
          }
          this.setState({
            excluded_rooms: exclude_rooms
          });
        }
        this.setState({
          intrusion_alerts: data.intrusion_alerts,
            alerts_status: data.intrusion_alerts.alerts_status,
            checked_in_alerts: data.intrusion_alerts.checked_in_alerts,
            checked_out_alerts: data.intrusion_alerts.checked_out_alerts,
            checked_alerts: data.intrusion_alerts.checked_in_alerts ? 'Check-in' : data.intrusion_alerts.checked_out_alerts ? 'Check-out' : "",
            notification: data.intrusion_alerts.notification,
            email: data.intrusion_alerts.email,
            sms: data.intrusion_alerts.sms,
            phone_numbers: data.intrusion_alerts.phone_numbers ? data.intrusion_alerts.phone_numbers : [],
            email_ids: data.intrusion_alerts.email_ids ? data.intrusion_alerts.email_ids : [],
            features: data.features ? data.features : this.state.features
        },()=>{
            console.log(this.state);
        })
      }, err => {}
    );
  }

  closeDialog() {
    this.setState({
      dialog: {
        head: '',
        body: '',
        open: false,
        actions: []
      }
    });
  }

 

    alertSettings(e){
        e.preventDefault();
        let payload = {};
        payload.hotel_id = ls.getUserDetails().hotel_id;
        payload.intrusion_alerts = {
            alerts_status: this.state.alerts_status,
            checked_in_alerts: this.state.checked_in_alerts,
            checked_out_alerts: this.state.checked_out_alerts,
            notification: this.state.notification,
            excluded_rooms: this.state.excluded_rooms
        };
        if(this.state.email_ids && this.state.email_ids.length){
            let emails = [];
            for(let i of this.state.email_ids){
                if(i!=""){
                    emails.push(i);
                }
            }
            if(emails.length){
                payload.intrusion_alerts.email = true;
                payload.intrusion_alerts.email_ids = emails;
            }
        }
        if(this.state.phone_numbers && this.state.phone_numbers.length){
            let phone_numbers = [];
            for(let i of this.state.phone_numbers){
                if(i!=""){
                    phone_numbers.push(i);
                }
            }
            if(phone_numbers.length){
                payload.intrusion_alerts.sms = true;
                payload.intrusion_alerts.phone_numbers = phone_numbers;
            }
        }
        ds.postAlertSettings(payload,
            (data) => {
                let dialog;
                dialog = {
                  open: true,
                  head: 'Success!',
                  body: 'Alert Settings updated successfully',
                  actions: [
                    <FlatButton
                      label="Okay"
                      primary
                      onClick={this.closeDialog.bind(this)}
                    />
                  ]
                };
                this.getAlertSettings();
          
                this.setState({
                  dialog: dialog
                });
            },
            (err) => {

            })
    }

  addEmailList(){
    let email_ids = this.state.email_ids;
    if(email_ids && email_ids.length == 10){
        let dialog;
        dialog = {
          open: true,
          head: 'Alert!',
          body: 'Cannot Add more than 10 emails',
          actions: [
            <FlatButton
              label="Okay"
              primary
              onClick={this.closeDialog.bind(this)}
            />
          ]
        };
  
        this.setState({
          dialog: dialog
        });
    } else {
        email_ids.push('');
        this.setState({
            email_ids: email_ids
        })
    }
  }

  addPhoneList(){
    let phone_numbers = this.state.phone_numbers;
    if (phone_numbers && phone_numbers.length == 10){
        let dialog;
      dialog = {
        open: true,
        head: 'Alert!',
        body: 'Cannot add more than 10 phone numbers',
        actions: [
          <FlatButton
            label="Okay"
            primary
            onClick={this.closeDialog.bind(this)}
          />
        ]
      };

      this.setState({
        dialog: dialog
      });
    }
    else {
        phone_numbers.push('');
        this.setState({
            phone_numbers: phone_numbers
        })
    }
  }

  render() {
    return (
      <div>
      <Box header={'Alert Settings'}>
        <Dialog
          title={this.state.dialog.head}
          autoScrollBodyContent={true}
          actions={this.state.dialog.actions}
          modal={false}
          open={this.state.dialog.open}
          onRequestClose={this.closeDialog.bind(this)}
        >
          {this.state.dialog.body || 'NA'}
        </Dialog>

        <div className="col-sm-12 zeroPadding">
          <form onSubmit={this.alertSettings.bind(this)}>
            <fieldset>
              <div style={{"display":"flex","paddingLeft":"15px"}}>
              {/* <section className="col-sm-4"> */}
                {/* <label className="false-placeholder1"> */}
                <div style={{ "marginTop": "1rem",
    "alignItems": "center",
    "fontSize": "0.9rem",
    "fontWeight": "700",
    "opacity": "0.6",
    "justifyContent": "center"}}>
                  Enable Intrusion Alerts - 
                  </div>
                {/* </label> */}
                <input style={{"background": "linear-gradient(to bottom, #00bdd4, #218490)"}} type="checkbox" className='toggle toggle__outline'
                checked={this.state.alerts_status ? true : false}
                onChange={(e)=>{
                  let value =this.state.alerts_status;
                  this.setState({
                    alerts_status: !value
                  })
                }}/>

                {/* <Select
                  id="days"
                  onBlurResetsInput={false}
                  onSelectResetsInput={false}
                  autoFocus
                  options={actionOptions}
                  searchable={true}
                  placeholder="Select Yes/No"
                  value={this.state.alerts_status}
                  onChange={(newValue) => {
                    if(newValue){
                        this.setState({
                            alerts_status: newValue.value,
                        });
                    }
                    else {
                        this.setState({
                            alerts_status: "",
                        });
                    }
                  }}
                /> */}

              {/* </section> */}
              </div>

              <section className="col-sm-12 mt-1vw zeroPadding">
                <section className="col-sm-6">
                  <label className="false-placeholder1">Select when to trigger Intrusion Alerts</label>
                  <Select
                  id="days"
                  onBlurResetsInput={false}
                  onSelectResetsInput={false}
                  autoFocus
                  options={checkedOptions}
                  searchable={true}
                  placeholder="Select"
                  value={this.state.checked_alerts}
                  onChange={(newValue) => {
                    if(newValue && newValue.value == 'Check-in'){
                        this.setState({
                            checked_alerts: newValue.value,
                            checked_in_alerts : true,
                            checked_out_alerts: false
                        });
                    }
                    if(newValue && newValue.value == 'Check-out'){
                        this.setState({
                            checked_alerts: newValue.value,
                            checked_in_alerts : false,
                            checked_out_alerts: true
                        });
                    }
                    if(newValue == null){
                        this.setState({
                            checked_alerts: "",
                            checked_in_alerts : false,
                            checked_out_alerts: false
                        });
                    }
                  }}
                />
                </section>
              </section>
              <section className="col-sm-12 mt-1vw zeroPadding">
                <section className="col-sm-6">
                  <label className="false-placeholder1">Exclude selected rooms from Intrusion Alerts</label>
                  <Select
                  id="days"
                  onBlurResetsInput={false}
                  onSelectResetsInput={false}
                  autoFocus
                  multi={true}
                  options={this.state.all_rooms}
                  searchable={true}
                  placeholder="Select Rooms to exclude"
                  value={this.state.excluded_rooms}
                  onChange={(newValue)=>{
                    if(newValue && newValue.length){
                      let exclude_rooms = [];
                      for(let i of newValue){
                        exclude_rooms.push(i.value);
                      }
                      this.setState({
                        excluded_rooms: exclude_rooms
                      })
                    }else{
                      this.setState({
                        excluded_rooms: []
                      })
                    }
                  }}
                  />
                </section>
              </section>
              <section className="col-sm-12 mt-1vw zeroPadding">
                <section className="col-sm-6">
                  <label className="false-placeholder1">Select ways to communicate Intrusion Alerts</label>
                </section>
              </section>
              <section className="col-sm-12 mt-1vw zeroPadding">
              {/* <section className="col-sm-4">
                <label className="false-placeholder1"> */}
                  <div style={{"display":"flex","paddingLeft":"15px"}}>
              {/* <section className="col-sm-4"> */}
                {/* <label className="false-placeholder1"> */}
                <div style={{ "marginTop": "1rem",
    "alignItems": "center",
    "fontSize": "0.9rem",
    "fontWeight": "700",
    "opacity": "0.6",
    "justifyContent": "center"}}>
                  Enable Notification Alerts - 
                  </div>
                {/* </label> */}
                <input style={{"background": "linear-gradient(to bottom, #00bdd4, #218490)"}} type="checkbox" className='toggle toggle__outline'
                checked={this.state.notification ? true : false}
                onChange={(e)=>{
                  let value =this.state.notification;
                  this.setState({
                    notification: !value
                  })
                }}/>

                {/* <Select
                  id="days"
                  onBlurResetsInput={false}
                  onSelectResetsInput={false}
                  autoFocus
                  options={actionOptions}
                  searchable={true}
                  placeholder="Select Yes/No"
                  value={this.state.notification}
                  onChange={(newValue) => {
                    if(newValue){
                        this.setState({
                            notification: newValue.value,
                        });
                    }
                    else {
                        this.setState({
                            notification: "",
                        });
                    }
                  }}
                /> */}
</div>
              {/* </section> */}
              </section>
            <section className="col-sm-12 mt-1vw zeroPadding">
                <section className="col-sm-3">
                <label className="false-placeholder1">Get Email Alerts</label>
                </section>

                 <section className="col-sm-3 zeroPadding">
                  <i className="material-icons primary pull-right"
                    style={{
                      cursor:'pointer',
                    }}
                    onClick={this.addEmailList.bind(this)}
                  >
                    add_circle
                  </i>
                </section> 
              </section>
              {/* <section className="col-sm-6 mt-1vw zeroPadding"> */}
                {/* <section className="col-sm-3">
                  <label className="false-placeholder1">Get SMS Alerts</label>
                </section>

                 <section className="col-sm-3 zeroPadding">
                  <i className="material-icons primary pull-right"
                    style={{
                      cursor:'pointer',
                    }}
                    onClick={this.addPhoneList.bind(this)}
                  >
                    add_circle
                  </i>
                </section>  */}
              {/* </section> */}
              <section className="col-sm-6 mt-1vw zeroPadding">
               {
                this.state.email_ids && this.state.email_ids.map((emailid, index) => {
                    return <div key = {index} className="mt-1vw col-sm-12">
                        <section className="col-sm-4">
                <div className="false-placeholder1">
                  Email Id - {index+1}
                  <i className="material-icons primary pull-right"
                    style={{
                      cursor:'pointer',
                    }}
                    onClick={() => {
                        let intrusions = this.state.intrusion_alerts;
                        let emails = this.state.email_ids;
                        emails.splice(index,1);
                        this.setState({
                            email_ids: emails,
                            intrusion_alerts: intrusions
                        })
                    }}
                  >
                    delete
                  </i>
                </div>

                <TextField
                  name="emailid"
                  className="w-100"
                  value={this.state.email_ids[index]}
                  onChange={(e, value) => {
                    let emails = this.state.email_ids;
                    emails[index] = value;
                    this.setState({
                        email_ids: emails
                    });
                  }}
                />

              </section>
                    </div>

                })
               }
               
              </section>
              {/* <section className="col-sm-6 mt-1vw zeroPadding">
               {
                this.state.phone_numbers.map((emailid, index) => {
                    return <div key = {index} className="mt-1vw col-sm-12">
                        <section className="col-sm-4">
                <div className="false-placeholder1">
                  Phone Number - {index+1}
                  <i className="material-icons primary pull-right"
                    style={{
                      cursor:'pointer',
                    }}
                    onClick={() => {
                        let phone_numbers = this.state.phone_numbers;
                        phone_numbers.splice(index,1);
                        this.setState({
                            phone_numbers: phone_numbers
                        })
                    }}
                  >
                    delete
                  </i>
                </div>

                <TextField
                  name="emailid"
                  className="w-100"
                  value={this.state.phone_numbers[index]}
                  onChange={(e, value) => {
                    let phone_numbers = this.state.phone_numbers;
                    phone_numbers[index] = value;
                    this.setState({
                        phone_numbers: phone_numbers
                    });
                  }}
                />

              </section>
                    </div>

                })
               }
              </section> */}

            </fieldset>

            <div className="mt-4vw align-right">
              <RaisedButton
                label={ 'Save'}
                primary
                onClick={this.alertSettings.bind(this)}
              />
            </div>
          </form>

        </div>
      </Box>
      {/* {this.state.features && this.state.features.sms && <div style={{"marginTop":"5rem"}}>
      <Box header={'SMS Feature'}>
      <div style={{"display":"flex"}}>
        <div style={{ "marginTop": "1rem",
    "alignItems": "center",
    "fontSize": "1.2rem",
    "opacity": "0.6",
    "justifyContent": "center"}}> SMS Messaging Service -  </div>
        <div>
      <input style={{    "background": "linear-gradient(to bottom, #00bdd4, #218490)"}} className="toggle toggle__outline" type="checkbox"
                              //disabled={obj.loaderFlag ? obj.loaderFlag : ''}
                              checked={this.state.features.sms && this.state.features.sms.enabled ?  true : false }
                              onChange={(e) => {
                                this.setState({
                                  dialog : {
                                    open: true,
                                    head: 'Alert!',
                                    body: 'Please Contact Administrator for this service.',
                                    actions: [
                                      <FlatButton
                                        label="Okay"
                                        primary
                                        onClick={this.closeDialog.bind(this)}
                                      />
                                    ]
                                  }
                                })
                              }}
                            />
                            </div>
      </div>
      </Box>
      </div>} */}
      <div style={{'padding':'1.5rem'}}>
       <Table
           // height={'45vh'}
            fixedHeader={true}
            fixedFooter={true}
            selectable={false}
            multiSelectable={false}
            bodyStyle={{ minWidth: 100, overflowX: 'auto' }}
          >
            <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
              <TableRow>
                <TableHeaderColumn tooltip="Intrusion Alerts">Intrusion Alerts</TableHeaderColumn>
                <TableHeaderColumn tooltip="When to Alert">When to Alert</TableHeaderColumn>
                <TableHeaderColumn tooltip="Excluded Rooms">Excluded Rooms</TableHeaderColumn>
                <TableHeaderColumn tooltip="Notifications">Notifications</TableHeaderColumn>
                <TableHeaderColumn tooltip="Email List">Email Alerts</TableHeaderColumn>
              </TableRow>
            </TableHeader>
            <TableBody
              displayRowCheckbox={false}
              showRowHover={true}
              stripedRows={false}
            >
               <TableRow key={'alerts'}>
                  <TableRowColumn style={{ overflow: 'visible' }}>
                  {this.state.intrusion_alerts.alerts_status ? <i className="material-icons" style={{color: 'green'}}>done</i> : <i className="material-icons" style={{color: 'red'}}>close</i>}
                  </TableRowColumn>
                  <TableRowColumn style={{ overflow: 'visible' }}>
                  {this.state.intrusion_alerts.checked_in_alerts ? 'Check-in' : this.state.intrusion_alerts.checked_out_alerts ? 'Check-out' : 'NA'}
                  </TableRowColumn>
                  <TableRowColumn style={{ overflow: 'visible' }}>
                   {this.state.intrusion_alerts.excluded_rooms && this.state.intrusion_alerts.excluded_rooms.length ? (
                    this.state.intrusion_alerts.excluded_rooms.map((room)=>{
                      return (<li>{room.name}</li>)
                    })) :'NA' }
                  </TableRowColumn>
                  <TableRowColumn style={{ overflow: 'visible' }}>
                   {this.state.intrusion_alerts.notification ?  <i className="material-icons" style={{color: 'green'}}>done</i> : <i className="material-icons" style={{color: 'red'}}>close</i>}
                  </TableRowColumn>
                  <TableRowColumn style={{ overflow: 'visible' }}>
                   {this.state.intrusion_alerts.email_ids ? (this.state.intrusion_alerts.email_ids.length && 
                    this.state.intrusion_alerts.email_ids.map((id)=>{
                      return (<li>{id}</li>)
                    })) : 'NA'}
                  </TableRowColumn>
                  </TableRow>
              </TableBody>
              <TableFooter>
              <TableRow>
                <TableRowColumn colSpan="7" style={{ textAlign: 'center' }}>

                </TableRowColumn>
                <TableRowColumn colSpan="3" style={{ textAlign: 'right' }}>
                  {/* {pagination} */}
                </TableRowColumn>
              </TableRow>
            </TableFooter>
            </Table>
            </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./components/settings/AlertSetting.js